<template>
    <v-col col-12>
        <v-progress-circular v-if="loading" size="50" color="primary" indeterminate></v-progress-circular>
        <v-row v-if="!loading" class="mt-5">
            <v-col cols="6">
                <h1 class="mb-5">UK Notices</h1>
                <editor v-model="notices.notices" :disabled="!editMode || saving" :init="editorOptions"></editor>
            </v-col>
            <v-col cols="6">
                <h1 class="mb-5">Denzapine UK</h1>
                <editor v-model="notices.contact_info" :disabled="!editMode || saving" :init="editorOptions"></editor>
            </v-col>
            <v-col cols="12" class="text-right">
                <v-btn v-if="!editMode" rounded color="primary" small @click="editMode = true">Edit</v-btn>
                <v-btn v-if="editMode" :disabled="saving" rounded color="secondary" small @click="cancel"
                    >Cancel
                </v-btn>
                <v-btn v-if="editMode" :disabled="saving" rounded color="primary" small @click="saveNotices"
                    >Save
                </v-btn>
            </v-col>
        </v-row>
    </v-col>
</template>
<script>
import Editor from '@tinymce/tinymce-vue';

export default {
    components: { Editor },
    data() {
        return {
            editMode: false,
            loading: true,
            saving: false,
            editorOptions: {
                plugins: 'link table',
                toolbar:
                    'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | table | removeformat',
                menubar: false,
                statusbar: false,
                height: 500,
            },
            temp: null,
            notices: {
                notices: '',
                contact_info: '',
            },
        };
    },
    created() {
        this.getNotices();
    },
    methods: {
        getNotices() {
            axios
                .get(route('api.v1.dashboard.notices.index'))
                .then((response) => {
                    this.notices = response.data;
                    this.temp = JSON.parse(JSON.stringify(response.data));
                    this.loading = false;

                    if (_.isEmpty(this.notices.notices) && _.isEmpty(this.notices.contact_info)) {
                        this.editMode = true;
                    }
                })
                .catch((error) => {
                    this.$root.notify('error', error.message);
                    this.loading = false;
                });
        },
        saveNotices() {
            this.saving = true;
            axios
                .post(route('api.v1.dashboard.notices.store'), this.notices)
                .then(() => {
                    this.$root.notify('success', 'Information updated successfully');
                    this.saving = false;
                    this.editMode = false;
                })
                .catch((error) => {
                    this.$root.notify('error', error.message);
                    this.saving = false;
                    this.editMode = false;
                });
        },
        cancel() {
            this.notices = JSON.parse(JSON.stringify(this.temp));
            this.editMode = false;
        },
    },
};
</script>
<style>
.tox-tinymce {
    border: 1px solid #ccc !important;
    border-radius: 20px !important;

    &--disabled {
        border-color: #ccc !important;
    }
}
</style>
